import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import { LinkButton } from '@/components/common/buttons'
import FlatIcon from '@/components/common/icons/FlatIcon'
import { CartItemCountCircle } from '@/components/domains/etc'
import { SearchBarInputText } from '@/components/domains/layouts/header/index'
import { PetTypeFilter } from '@/components/domains/search'
import { IconNameEnum } from '@/constants/icon-name.enum'
import { IconSizeEnum } from '@/constants/icon-size.enum'
import { LAYOUT_UNITS, Z_INDEXES } from '@/constants/legacy/constLayout'
import ROUTES from '@/constants/legacy/constRoutes'
import { HeaderIdEnum } from '@/constants/local-navigation-tab-title.enum'
import { SearchResultContainer } from '@/containers/search/search-result.context'
import { Bridge } from '@/utils/bridge/bridge'
import appBridgeProvider, { isInAppFlag } from '@/utils/utilBridge'

const NoSSRSearchProductFilter = dynamic(() => import('@/components/common/etc/SearchProductFilter'), {
  ssr: false,
})
const NoSSRRelatedSearchKeywords = dynamic(() => import('@/components/domains/layouts/header/RelatedSearchKeywords'), {
  ssr: false,
})

//spring rest api 용 컴포넌트
const SearchProductHeader = () => {
  const { pathname } = useRouter()
  const { refetch, headerRefCallback } = SearchResultContainer.useContainer()

  const handleLinkButton = () => {
    if (isInAppFlag) {
      appBridgeProvider((bridge: Bridge) => bridge.goDeepLink('fitpetmall', '/main'))
    }
  }

  return (
    <StyledHeader ref={headerRefCallback} id={HeaderIdEnum.Header}>
      <div id="header-above-nav">
        <StyledSearchBarContainer>
          <LinkButton goBack>
            <FlatIcon type={IconNameEnum.IcBack} size={IconSizeEnum.Size24} />
          </LinkButton>
          <StyledSearchBarInputText>
            <SearchBarInputText onRefetch={refetch} />
          </StyledSearchBarInputText>
          <StyledIconContainer style={{ paddingRight: '0' }}>
            {pathname !== ROUTES.SEARCH && (
              <LinkButton
                url={isInAppFlag ? undefined : ROUTES.INDEX}
                onClick={handleLinkButton}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <FlatIcon type={IconNameEnum.IcHome} size={IconSizeEnum.Size24} />
              </LinkButton>
            )}
            <LinkButton rel="nosublink" url={ROUTES.CART} style={{ display: 'flex', alignItems: 'center' }}>
              <CartItemCountCircle />
              <FlatIcon type={IconNameEnum.IcCart} size={IconSizeEnum.Size24} />
            </LinkButton>
          </StyledIconContainer>
        </StyledSearchBarContainer>

        {pathname !== ROUTES.SEARCH && <NoSSRRelatedSearchKeywords />}
        <PetTypeFilter />
        {pathname !== ROUTES.SEARCH && <NoSSRSearchProductFilter />}
      </div>
    </StyledHeader>
  )
}

const StyledHeader = styled.div`
  z-index: ${Z_INDEXES.HEADER};
  position: sticky;
  top: 0;
  width: 100%;
  max-width: ${LAYOUT_UNITS.BODY_MAX_WIDTH};
  background-color: ${({
    theme: {
      color: { grayWhite },
    },
  }) => grayWhite};
  transition: transform 0.2s;
  -webkit-transition: transform 0.2s;
`

const StyledSearchBarContainer = styled.div`
  padding-left: 1.6rem;
  padding-right: 1.6rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.6rem;
  height: 5.8rem;
  flex-flow: nowrap;
`

const StyledIconContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 100%;
  min-height: 1px;
  padding-inline-end: 0;
`

const StyledSearchBarInputText = styled.div`
  flex: 1;
`

export default SearchProductHeader
